import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, XIcon } from 'lucide-react';
interface ExitRibbonProps {
  webinarUrl: string;
  /** Respaldo para móvil, donde no existe la intención de salida con el cursor. */
  fallbackDelayMs?: number;
}
const STORAGE_KEY = 'sube-de-nivel:exit-ribbon-dismissed';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ExitRibbon({
  webinarUrl,
  fallbackDelayMs = 30000
}: ExitRibbonProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
    function show() {
      setIsVisible(true);
    }
    function handleMouseOut(event: MouseEvent) {
      if (event.clientY <= 0 && !event.relatedTarget) show();
    }
    document.addEventListener('mouseout', handleMouseOut);
    const timer = window.setTimeout(show, fallbackDelayMs);
    return () => {
      document.removeEventListener('mouseout', handleMouseOut);
      window.clearTimeout(timer);
    };
  }, [fallbackDelayMs]);
  function dismiss() {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setIsVisible(false);
  }
  return <AnimatePresence data-id="element-73" data-mp="3lt4r7fwkrwem">
      {isVisible && <motion.aside initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.28,
      ease: EASE
    }} className="fixed inset-x-0 bottom-0 z-40 bg-[#B3261E] text-hueso" aria-label="Recordatorio del webinar gratuito" data-id="element-74" data-mp="380wwdtouqfik">
          <div className="mx-auto flex w-full max-w-5xl flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:py-3.5" data-id="element-75" data-mp="8jguw8preq3r">
            <p className="pr-8 font-sans text-base leading-snug sm:pr-0" data-id="element-76" data-mp="3vpg3w702uo9l">
              <span className="font-semibold" data-id="element-77" data-mp="3vrkjhm7c9bpp">Antes de irte:</span> no olvides sumarte al webinar
              gratis.
            </p>

            <div className="flex items-center gap-3" data-id="element-78" data-mp="2ka15qzw4tqcw">
              <a href={webinarUrl} target="_blank" rel="noopener noreferrer" className="group inline-flex flex-1 items-center justify-center gap-2 rounded-sm bg-dorado px-6 py-3 font-sans text-sm font-bold text-noche transition-colors duration-150 ease-out hover:bg-dorado-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-hueso focus-visible:ring-offset-2 focus-visible:ring-offset-[#B3261E] sm:flex-none sm:text-base" data-id="element-79" data-mp="2kbm5d3xazzhm">
                Quiero Sumarme al Webinar Gratis
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-80" data-mp="248fs20jd89u" />
              </a>
            </div>
          </div>

          <button type="button" onClick={dismiss} aria-label="Cerrar aviso" className="absolute right-3 top-3 rounded-sm p-1.5 text-hueso/70 transition-colors duration-150 ease-out hover:text-hueso focus:outline-none focus-visible:ring-2 focus-visible:ring-hueso sm:top-1/2 sm:-translate-y-1/2" data-id="element-81" data-mp="3pbamar2om74k">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="3adivplh9rp3k" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}